import { render } from "./MenuPanel.vue?vue&type=template&id=8f0efdbc&scoped=true"
import script from "./MenuPanel.vue?vue&type=script&lang=js"
export * from "./MenuPanel.vue?vue&type=script&lang=js"

import "./MenuPanel.vue?vue&type=style&index=0&id=8f0efdbc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f0efdbc"]])

export default __exports__